var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseVid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7728,
    cy: 31.7728,
    r: 30.9476,
    fill: "#D9D9D9",
    fillOpacity: 0.66,
    stroke: "white",
    strokeWidth: 1.65054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_28535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7712 7.43375C18.3257 7.43375 7.42578 18.3336 7.42578 31.7792C7.42578 45.2247 18.3257 56.1246 31.7712 56.1246C45.2177 56.1246 56.1166 45.2247 56.1166 31.7792C56.1166 18.3336 45.2177 7.43375 31.7712 7.43375ZM31.7712 51.2555C21.0319 51.2555 12.2949 42.5184 12.2949 31.7792C12.2949 21.0399 21.0319 12.3028 31.7712 12.3028C42.5105 12.3028 51.2475 21.0399 51.2475 31.7792C51.2475 42.5184 42.5105 51.2555 31.7712 51.2555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9375 24.6875C29.2837 24.6875 30.375 25.7788 30.375 27.125V36.875C30.375 38.2212 29.2837 39.3125 27.9375 39.3125C26.5913 39.3125 25.5 38.2212 25.5 36.875V27.125C25.5 25.7788 26.5913 24.6875 27.9375 24.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0625 24.6875C37.4087 24.6875 38.5 25.7788 38.5 27.125V36.875C38.5 38.2212 37.4087 39.3125 36.0625 39.3125C34.7163 39.3125 33.625 38.2212 33.625 36.875V27.125C33.625 25.7788 34.7163 24.6875 36.0625 24.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_28535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.6908,
    height: 48.6908,
    fill: "white",
    transform: "translate(7.42969 7.43179)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseVid);
export default __webpack_public_path__ + "static/media/pause_vid.ad9f44a3cd5c8a0f39a15270c63414d5.svg";
export { ForwardRef as ReactComponent };